import { render, staticRenderFns } from "./ModalAssignBenhAn.vue?vue&type=template&id=c4f3b562&scoped=true"
import script from "./ModalAssignBenhAn.vue?vue&type=script&lang=js"
export * from "./ModalAssignBenhAn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f3b562",
  null
  
)

export default component.exports